<template>
  <div class="app-consent-text-view">
    <div class="consent-text-not-explicit" v-if="!explicit" v-html="consentText.text"></div>
    <div v-else class="input-consent">
      <div class="custom-checkbox">
        <input type="checkbox"
               :id="`input-consent-${_uid}`"
               v-model="selected_"
               class="consent-checkbox">
        <label :for="`input-consent-${_uid}`"></label>
      </div>

      <label :for="`input-consent-${_uid}`" class="consent-label">
        <p>
          <span class="consent-label" v-html="consentText.text"></span>
        </p>
      </label>
    </div>
  </div>
</template>

<script>
import syncProperty from '../../../../mixins/syncProperty'

export default {
  name: 'ConsentTextAccept',
  mixins: [
    syncProperty('selected', 'selected_')
  ],
  props: {
    consentText: {
      type: Object,
      required: true
    },
    // does the user need to check a checkbox
    explicit: {
      type: Boolean,
      default: true
    }
  }
}
</script>
